'use strict';

var _learnq = window._learnq || [];
var klaviyo = {
  addtoCart: function (item, data) {
    if (window.location.hostname != 'www.neptune.com') {
      return;
    }
    try {
      var obj = {};
      if (data != null) {
        var cart = {
          total_price: data.total_price / 100,
          $value: data.total_price / 100,
          total_discount: data.total_discount,
          original_total_price: data.original_total_price / 100,
          items: data.items,
        };
        obj = cart;
      } else {
        var priceKeys = [
          'final_line_price',
          'original_price',
          'original_line_price',
          'line_price',
          'price',
          'discounted_price',
          'final_price',
        ];
        Object.keys(item).forEach(k => {
          if (priceKeys.filter(f => f == k).length > 0) {
            item[k] = item[k] / 100;
          }
        });
        obj = item;
      }
      var tracking = ['track', 'Added to Cart', obj];
      _learnq.push(tracking);
    } catch (ex) {}
  },
};
(document.addEventListener('flu:cart:item-added', function (t) {
  klaviyo.addtoCart(t.detail.product, null);
  window.neptune.clarity('add_to_cart');
}),
  document.addEventListener('flu:cart:updated', function (t) {
    showMadeToOrderText(t.detail.cart);
    if (window.neptune.suft['init']) {
      window.neptune.suft.init();
    }
  }),
  document.addEventListener('flu:cart:error', function (t) {
    if (
      t.detail.errorMessage
        .toLowerCase()
        .indexOf('the maximum quantity of this item is already in your cart') != -1
    ) {
      var stockElementerror = document.querySelector('.product__quantity-error');
      if (stockElementerror != null) {
        stockElementerror.innerHTML = theme.strings.cart.general.quantity_error;
        stockElementerror.classList.remove('hidden');
      }
    }
  }),
  document.addEventListener('flu:quick-cart:open', function (t) {
    window.setHawkIndex();
    window.showMadeToOrderText(t.detail.cart);
  }),
  document.addEventListener('flu:quick-cart:close', function () {}),
  document.addEventListener('flu:product:variant-change', function (t) {
    setTimeout(function () {
      window.neptune.variant.update(t).then(e => {
        window.neptune.variant.images.update();
        typeof window.neptune.configured['_glob'] != 'undefined'
          ? window.neptune.configured._glob.refresh(true)
          : null;
      });
    });
  }),
  document.addEventListener('flu:product:quantity-update', function (t) {}));
function findVariantById(id) {
  return Object.entries(shopify_product).reduce((a, [variant, variantData]) => {
    variantData.id == id ? (a[variant] = variantData) : '';
    return a;
  }, {});
}
function htmlDecode(input) {
  var e = document.createElement('textarea');
  e.innerHTML = input;
  return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
}
function setHawkIndex() {
  const frame = document.querySelector('iframe[title="chat widget"]');
  if (frame == null) {
    return;
  }
  frame.parentNode.setAttribute('style', frame.getAttribute('style') + '; z-index:1!important;');
}
function showMadeToOrderText(cart) {
  var madeToOrder = [];
  const basketMsgElement = document.querySelector('.js-madetoorder-basket');
  const cartNote = document.querySelector('.js-cart-note');
  if (
    basketMsgElement == null ||
    cart == null ||
    (basketMsgElement != null && basketMsgElement.innerText.length < 5)
  ) {
    return;
  }
  cart.items
    .filter(e => e.properties != null)
    .map(x => x.properties)
    .forEach(f => {
      Object.keys(f).forEach(h => {
        if (h == '_AV | Availability' && f[h].toLowerCase().indexOf('to order') != -1) {
          madeToOrder.push(Math.random());
        }
      });
    });
  cart.items
    .filter(e => e.options_with_values.find(r => r.name.toLowerCase() == 'fabric') != null)
    .forEach(e => {
      madeToOrder.push(Math.random());
    });
  if (madeToOrder.length > 0) {
    basketMsgElement.style.display = 'block';
    basketMsgElement.style.opacity = 1;
    basketMsgElement.style.height =
      basketMsgElement.querySelector('.basket-text-inner').clientHeight + 'px';
  } else {
    basketMsgElement.style.height = '0px';
    basketMsgElement.style.opacity = 0;
    basketMsgElement.style.display = 'none';
    cartNote.style.marginTop = '0px';
  }
}
window.addEventListener('load', e => {
  window.lazySizes != null ? window.lazySizes.autoSizer.checkElems() : null;

  try {
    if (document.querySelector('.keec-modal') != null) {
      var x = document.querySelector('script[src*="/assets/"]').src.split('.js')[0];
      x = x.substring(0, x.lastIndexOf('/'));
      var y = document.createElement('link');
      y.href = x + '/keec-modal.css';
      y.type = 'text/css';
      y.setAttribute('rel', 'stylesheet');
      document.body.append(y);
    }
  } catch (e) {
    console.log(e);
  }

  setTimeout(function () {
    if (window['$__TawkEngine'] == null) {
      return;
    }
    var Tawk_API = Tawk_API || {},
      Tawk_LoadStart = new Date();
    Tawk_API.environmentId =
      window.location.hostname == 'www.neptune.com'
        ? '64870f74cc26a871b0220754/1h2np8o3q'
        : '63ff7b894247f20fefe3642f/1gqevl46g';

    var s1 = document.createElement('script'),
      s0 = document.getElementsByTagName('script')[0];
    s1.async = true;
    s1.src = 'https://embed.tawk.to/' + Tawk_API.environmentId;

    s1.setAttribute('crossorigin', '*');
    s0.parentNode.insertBefore(s1, s0);
  }, 5000);
});
